import { useEffect, useState } from 'react';
import { IconBell, IconChecklist } from '@tabler/icons-react';
import { HeaderTool } from '@hana/shell';
import { DOCK_NOTIS, tasksFor } from './dock';
import s from './dock.module.css';

// Bảng phải 372 của Mint-Training (Việc · Thông báo): ≥ 1800 dính mép phải mở sẵn "Việc"; 2 nút ở đầu trang chuyển tab (nhỏ hơn 1800 bấm lần nữa để đóng).

type DockKey = 'task' | 'noti';

export function EduDock({ initial, manager, onClose }: { initial: DockKey; manager: boolean; onClose: () => void }) {
  const [tab, setTab] = useState<DockKey>(initial);
  const [done, setDone] = useState<ReadonlySet<number>>(new Set());
  const tasks = tasksFor(manager);
  const tabs = [
    { key: 'task' as const, label: 'Việc', n: tasks.length },
    { key: 'noti' as const, label: 'Thông báo', n: DOCK_NOTIS.length },
  ];
  const toggle = (i: number) => {
    const n = new Set(done);
    if (n.has(i)) n.delete(i);
    else n.add(i);
    setDone(n);
  };
  return (
    <div className={s.dock} aria-label="Bảng bên phải">
      <div className={s.head}>
        <div role="tablist" aria-label="Bảng bên phải" className={s.tabs}>
          {tabs.map((t) => (
            <button key={t.key} type="button" role="tab" aria-selected={tab === t.key} className={`${s.tab} ${tab === t.key ? s.on : ''}`} onClick={() => setTab(t.key)}>
              {t.label} <span>{t.n}</span>
            </button>
          ))}
        </div>
        <button type="button" className={s.close} aria-label="Đóng bảng" onClick={onClose}>×</button>
      </div>
      {tab === 'task' &&
        tasks.map((t, i) => (
          <div key={t.k} className={s.task} style={{ opacity: done.has(i) ? 0.5 : 1 }}>
            <input type="checkbox" aria-label={`Xong: ${t.k}`} checked={done.has(i)} onChange={() => toggle(i)} />
            <div>
              <div className={s.tk} style={{ textDecoration: done.has(i) ? 'line-through' : 'none' }}>{t.k}</div>
              <div className={s.meta}><b>{t.code}</b> · <span className={t.late ? s.late : undefined}>{t.due}</span></div>
            </div>
          </div>
        ))}
      {tab === 'noti' &&
        DOCK_NOTIS.map((n) => (
          <div key={n.k} className={s.noti}>
            <span className={s.dot} data-tone={n.tone} />
            <div>
              <div style={{ fontWeight: n.unread ? 600 : 450 }}>{n.k}</div>
              <div className={s.when}>{n.when}</div>
            </div>
          </div>
        ))}
    </div>
  );
}

/** Trạng thái bảng phải + 2 nút đầu trang. `dk` undefined = theo khổ (≥ 1800 mở sẵn "Việc"). */
export function useEduDock(manager: boolean, enabled: boolean) {
  const [wide, setWide] = useState(() => matchMedia('(min-width: 1800px)').matches);
  const [dk, setDk] = useState<DockKey | null | undefined>(undefined);
  useEffect(() => {
    const mq = matchMedia('(min-width: 1800px)');
    const on = () => setWide(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  const kind = !enabled ? null : dk === undefined ? (wide ? 'task' : null) : dk;
  const n = tasksFor(manager).length;
  return {
    dock: kind ? <EduDock key={kind} initial={kind} manager={manager} onClose={() => setDk(null)} /> : undefined,
    tools: (
      <>
        <HeaderTool label="Việc" icon={IconChecklist} n={n} active={kind === 'task'} onClick={() => setDk(kind === 'task' && !wide ? null : 'task')} />
        <HeaderTool label="Thông báo" icon={IconBell} n={DOCK_NOTIS.length} active={kind === 'noti'} onClick={() => setDk(kind === 'noti' && !wide ? null : 'noti')} />
      </>
    ),
  };
}
